import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Topbar from '../components/Topbar.jsx';
import Statusbar from '../components/Statusbar.jsx';
import StudyRow from '../components/StudyRow.jsx';
import { patientTimeline } from '../api/client.js';
import styles from './Timeline.module.css';

export default function Timeline() {
  const { patientId } = useParams();
  const [studies, setStudies] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let aborted = false;
    (async () => {
      try {
        const rows = await patientTimeline(patientId);
        if (!aborted) setStudies(rows);
      } catch (err) {
        if (!aborted) setError(err.message || 'Load failed');
      }
    })();
    return () => { aborted = true; };
  }, [patientId]);

  const first = studies && studies[0];
  const patientName = first?.patient_name || '—';
  const grouped = groupByYear(studies || []);

  return (
    <div className={styles.shell}>
      <Topbar breadcrumb={`Timeline · MRN ${patientId}`} />
      <div className={styles.head}>
        <div>
          <div className={styles.name}>{patientName}</div>
          <div className={styles.meta}>MRN {patientId} · {studies ? studies.length : '—'} studies</div>
        </div>
        <Link to="/" className={styles.back}>← Worklist</Link>
      </div>
      {error ? <div className={styles.err}>{error}</div> : null}
      {studies === null ? (
        <div className={styles.empty}>Loading…</div>
      ) : studies.length === 0 ? (
        <div className={styles.empty}>No studies for this MRN.</div>
      ) : (
        <div className={styles.list}>
          {grouped.map(({ year, items }) => (
            <section key={year} className={styles.year}>
              <h2 className={styles.yearHeader}>{year}</h2>
              {items.map(s => <StudyRow key={s.study_instance_uid} study={s} />)}
            </section>
          ))}
        </div>
      )}
      <Statusbar right={`Lumen · timeline for ${patientId}`} />
    </div>
  );
}

function groupByYear(rows) {
  const out = new Map();
  for (const r of rows) {
    const year = (r.study_date ? String(r.study_date).slice(0, 4) : 'Undated');
    if (!out.has(year)) out.set(year, []);
    out.get(year).push(r);
  }
  return [...out.entries()].sort((a, b) => b[0].localeCompare(a[0])).map(([year, items]) => ({ year, items }));
}
